(function () {
  'use strict';

  angular.module('ringbaPortal').component('targetForm', {
    bindings: {
      currentTarget: '<',
      addRouteEnabled: '<',
      isModal: '<',
      addRoute: '&',
      onSave: '&',
      onDismiss: '&',
      isRpc: '<',
    },
    controller: TargetFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/target-form.view.html'
  });

  function TargetFormController(
    _,
    $scope,
    $q,
    $filter,
    $uibModal,
    $timeout,
    accountsService,
    accountSettingsService,
    infoService,
    tagService,
    targetService,
    buyerService,
    capSettingsService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;
    vm.callTypes = targetService.callTypes;
    vm.newTargetForm = {};
    vm.regex_digits_optional = new RegExp('\\d*');
    vm.currentCallRoute = {};
    vm.callCaps = {};
    vm.targetOwnerCopy = null; // Maintain copy of owner ID, in case we need to call the unlink buyer
    vm.save = save;
    vm.setHours = false;
    vm.isTagFilterSectionOpen = false;
    vm.isRefreshingBuyers = false;
    vm.isLoadingTags = false;

    vm.rpcSettingInContext;
    vm.parentRPCSettings;
    vm.parentRPCSettingLabel;
    vm.overrideRpcSetting = false;
    vm.isRpcSettingReadOnly = false;
    vm.buyerExternalLink;

    vm.showFullWidthOptions = {
      showSummaryView: false
    };

    vm.overrideShareableTags = false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onScheduleChange = onScheduleChange;
    vm.showOwner = showOwner;
    vm.showType = showType;
    vm.validateDuplicacy = validateDuplicacy;
    vm.onCallTypeChange = onCallTypeChange;
    vm.showTagFilterSection = showTagFilterSection;
    vm.removeAllFilters = removeAllFilters;
    vm.confirmResetCapCounters = confirmResetCapCounters;
    vm.resetCapCounters = resetCapCounters;
    vm.cancelModal = cancelModal;
    vm.setSelectedOwner = setSelectedOwner;
    vm.onTargetDupeSettingsChange = onTargetDupeSettingsChange;
    vm.onRPCSettingsChange = onRPCSettingsChange;
    vm.onRPCChange = onRPCChange;
    vm.onPriorityBumpChange = onPriorityBumpChange;
    vm.onRPCSettingToggled = onRPCSettingToggled;
    vm.targetCapTypes = targetService.targetCapTypes;
    vm.matrixUpdated = matrixUpdated;
    vm.onWeekDayMatrixUpdated = onWeekDayMatrixUpdated;
    vm.toggleSetHours = toggleSetHours();
    vm.onWeekDaySumMatrixUpdated = onWeekDaySumMatrixUpdated;
    vm.tagRoutingFilterGroupLogicTooltip = $filter('translate')(
      'TAG_ROUTING_FILTERS_GROUP_BY_TT'
    );
    vm.onNumberChange = onNumberChange;
    vm.onRefreshBuyers = onRefreshBuyers;
    vm.updateRevenueRecoverySetting = updateRevenueRecoverySetting;
    vm.validateTagRoutingFilters = validateTagRoutingFilters;
    vm.isButtonDisabled = false;
    vm.isTagRoutingFiltersInvalid = false;
    vm.isRevenueRecoveryInvalid = false;

    // Revenue Recovery options, default starts out with generic label for parent setting
    vm.revenueRecoverySettingsOptions = [
      { name: $filter('translate')('USE_PARENT_SETTING'), value: null },
      { name: $filter('translate')('ENABLED_TEXT'), value: true },
      { name: $filter('translate')('DISABLED_TEXT'), value: false }
    ];

    vm.onUpdateSipHeaders = onUpdateSipHeaders;

    function onInit() {
      vm.isAdmin = accountsService.isAdmin();
      vm.isReadOnly = accountsService.isBuyer();

      _loadTimeZones();
      if (!vm.isReadOnly) {
        _loadBuyers();
      }
      _loadTags();

      vm.currentTarget = vm.currentTarget || targetService.initNewTarget();
      vm.isPhoneNumberValid = !!vm.currentTarget.id;
      if (vm.currentTarget.shareableTagSetting?.macroTagstoShare)
        vm.overrideShareableTags = true;

      _initRpcSettingItem();
      validateTagRoutingFilters();
      _initRevenueRecoveryParentSetting();
    }

    function onChanges(changesObj) {
      if (changesObj.currentTarget && typeof vm.currentTarget !== 'undefined') {
        vm.isPhoneNumberValid = !!vm.currentTarget.id;
        vm.cannotBuyerSetConcurrencyCap =
          accountsService.isBuyer() &&
          !_getCanSetConcurrencyCapPermission(vm.currentTarget);
        vm.targetOwnerCopy = angular.copy(vm.currentTarget.owner);
        toggleSetHours();
        if (vm.currentTarget.owner && vm.currentTarget.owner.routeDuplicates) {
          vm.routeDuplicatesBuyer = vm.currentTarget.owner.routeDuplicates;
        } else {
          vm.routeDuplicatesBuyer = null;
        }

        if (vm.currentTarget.schedule) {
          _initializeCallCaps();
          if (
            vm.currentTarget.schedule.callConcurrencyMatrix &&
            vm.currentTarget.schedule.callConcurrencyMatrix.length > 0
          ) {
            vm.setConcurrency = true;
            vm.showAdvancedConcurrency = !_isBasicConcurrency(
              vm.currentTarget.schedule.callConcurrencyMatrix
            );
          }
        }

        _checkAndShowTagFilter();
        _initRpcSettingItem();
      }
    }

    $scope.$on('onLoadingBulkTags', (event, data) => {
      vm.isButtonDisabled = data;
    });

    function _getCanSetConcurrencyCapPermission(target) {
      return target && target.owner && target.owner.canSetConcurrencyCaps;
    }

    function showOwner() {
      return !accountsService.isBuyer();
    }

    function setSelectedOwner() {
      if (vm.currentTarget.owner && vm.currentTarget.owner.id) {
        vm.routeDuplicatesBuyer = vm.buyers.find(function (buyer) {
          return buyer.id === vm.currentTarget.owner.id;
        }).routeDuplicates;
      } else {
        vm.routeDuplicatesBuyer = null;
      }
      _initRevenueRecoveryParentSetting();
    }

    function onTargetDupeSettingsChange(value) {
      vm.currentTarget.routeDuplicates = value;
    }

    function onRPCSettingToggled(isEnabled) {
      if (isEnabled == null) {
        // account setting will take precedence
        vm.isRpcSettingReadOnly = true;
        vm.rpcSettingInContext = vm.parentRPCSettings;

        return;
      }

      vm.isRpcSettingReadOnly = false;
      vm.rpcSettingInContext = {
        erpcSetting: null,
        useERPC: isEnabled.value
      };

      vm.overrideRpcSetting = isEnabled.value;
      vm.rpcItem = {
        enabled: isEnabled.value,
        id: ''
      };
    }

    function onRPCSettingsChange(value) {
      vm.rpcSettingInContext = value;
    }

    function onRPCChange(value) {
      vm.rpcItem.id = value;
    }

    function onPriorityBumpChange(value) {
      vm.currentTarget.priorityBump = value;
    }

    function showType() {
      return !accountsService.isBuyer();
    }

    function onScheduleChange(hoursOfOperation) {
      vm.currentTarget.schedule = vm.currentTarget.schedule || {};
      vm.currentTarget.schedule.hoursOfOperation = hoursOfOperation;
    }

    function save() {
      if (accountsService.isBuyer() && !vm.cannotBuyerSetConcurrencyCap) {
        return _saveBuyerConcurrencyCap().then(function (updatedTarget) {
          vm.onSave({
            $event: {
              target: updatedTarget
            }
          });
        });
      } else if (vm.isAdmin) {
        vm.currentTarget.rpcSetting = !vm.isRpcSettingReadOnly
          ? this.rpcSettingInContext
          : null;

        return _createUpdateTarget().then(function (updateTarget) {
          if (updateTarget) {
            vm.onSave({
              $event: {
                newTarget: !vm.currentTarget.id,
                target: updateTarget
              }
            });
            vm.targetOwnerCopy = angular.copy(updateTarget.owner);
          }
        });
      }
      return $q.when({});
    }

    function _saveBuyerConcurrencyCap() {
      _resetCallCaps();
      return targetService
        .buyerSetConcurrencyCap(
          accountsService.currentAccountId,
          vm.currentTarget.id,
          {
            callConcurrencyMatrix:
              vm.currentTarget.schedule.callConcurrencyMatrix,
            concurrencyCap: vm.currentTarget.schedule.concurrencyCap,
            callCapMatrix: vm.currentTarget.schedule.callCapMatrix,
            allTimeCap: vm.currentTarget.schedule.allTimeCap,
            allTimeSumCap: vm.currentTarget.schedule.allTimeSumCap,
            monthlyCap: vm.currentTarget.schedule.monthlyCap,
            monthlySumCap: vm.currentTarget.schedule.monthlySumCap,
            dailyCap: vm.currentTarget.schedule.dailyCap,
            dailyCapDayOfWeek: vm.currentTarget.schedule.dailyCapDayOfWeek,
            dailySumCapDayOfWeek:
              vm.currentTarget.schedule.dailySumCapDayOfWeek,
            hourlySumCap: vm.currentTarget.schedule.hourlySumCap
          }
        )
        .then(function (response) {
          toaster.pop(
            'success',
            $filter('translate')('TARGET_CC_UPDATE_SUCCESS')
          );
          return response.data.target;
        })
        .catch(utils.errorHandler);
    }

    function validateDuplicacy(newValue) {
      if (newValue) {
        targetService
          .checkIfDuplicate(accountsService.currentAccountId, {
            id: vm.currentTarget.id,
            name: vm.currentTarget.name,
            accountId: vm.currentTarget.accountId
          })
          .then(function (response) {
            /*
          if (vm.newTargetForm.phoneNumber) {
            vm.newTargetForm.phoneNumber.$setValidity("duplicate", !response.data.isDuplicatePhoneNumber);
          }

          if (vm.newTargetForm.SIPNumber) {
            vm.newTargetForm.SIPNumber.$setValidity("duplicate", !response.data.isDuplicateSIP);
          }*/

            if (vm.newTargetForm && vm.newTargetForm.name) {
              vm.newTargetForm.name.$setValidity(
                'duplicate',
                !response.data.isDuplicateName
              );
            }
          });
      }
    }

    function showTagFilterSection() {
      vm.isTagFilterSectionOpen = true;
      vm.showFullWidthOptions.showSummaryView = false;
    }

    function removeAllFilters() {
      vm.isTagFilterSectionOpen = false;
      vm.currentTarget.criteria = [];
    }

    function resetCapCounters() {
      return targetService
        .resetCallCounters(
          accountsService.currentAccountId,
          vm.currentTarget.id
        )
        .then(function () {
          toaster.pop(
            'success',
            $filter('translate')('RESET_COUNTERS_SUCCESS')
          );
          vm.cancelModal();
        })
        .catch(utils.errorHandler);
    }

    function confirmResetCapCounters() {
      vm.modalBodyText = $filter('translate')('RESET_COUNTERS_MODAL_BODY', {
        target: 'Target'
      });
      vm.modal = $uibModal.open({
        templateUrl:
          '/scripts/shared/components/select-target/reset-target-counters.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function _deferredOnUpdate(promiseTarget, isUpdate) {
      return promiseTarget
        .then(function (response) {
          const target = response.data.target;

          function onSuccess() {
            toaster.pop(
              'success',
              $filter('translate')(
                isUpdate ? 'TARGET_UPDATE_SUCCESS' : 'TARGET_CREATE_SUCCESS'
              )
            );
            return target;
          }

          if (vm.currentCallRoute && vm.addRouteEnabled) {
            vm.currentCallRoute.targetid = target.id;
            vm.currentCallRoute.callTarget = target;
            return vm
              .addRoute({ route: vm.currentCallRoute })
              .then(onSuccess)
              .catch(function (error) {
                utils.errorHandler(error);
                return error;
              });
          } else {
            return onSuccess();
          }
        })
        .catch(utils.errorHandler);
    }

    function _deferredDealWithDuplicate(promiseTarget) {
      return promiseTarget
        .then(function (response) {
          return response;
        })
        .catch(_handleDuplicateError);
    }

    function _handleDuplicateError(response) {
      if (response.data.isDuplicate) {
        let message = 'TARGET_ERROR_DUP_GENERAL';

        if (response.data.isDuplicateName) {
          message = 'TARGET_ERROR_DUP_NAME';
          vm.newTargetForm.name.$setValidity('duplicate', false);
        }

        if (response.data.isDuplicatePhoneNumber) {
          message = 'TARGET_ERROR_DUP_PHONE';
        }

        if (response.data.isDuplicateSIP) {
          message = 'TARGET_ERROR_DUP_SIP';
        }

        return $q.reject({
          data: {
            message: $filter('translate')(message)
          }
        });
      } else {
        return $q.reject(response);
      }
    }

    function onCallTypeChange($event) {
      vm.currentTarget.instructions.callType = $event.newValue;
    }

    function onNumberChange(numberChange) {
      vm.currentTarget.instructions.number = numberChange.phoneNumber;
      vm.isPhoneNumberValid = numberChange.isValid;
    }

    // TODO: Push this up to select target component
    function _createUpdateTarget() {
      _resetCallCaps();
      _resetHours();

      let promiseTarget;
      const isUpdating = !!vm.currentTarget.id;

      if (vm.overrideShareableTags) {
        _processShareableTags();
      } else {
        _resetShareableTags();
      }

      // If there isn't an existing rpc object and a user created predictive routing config is selected, null out the rpcSetting object
      if (!vm.currentTarget.rpc && vm.rpcItem?.id) {
        vm.currentTarget.rpcSetting = null;
      }
      // If migrated predictive routing config was enabled but a user created predictive routing config is selected, null out the rpcSetting object
      if (
        vm.currentTarget.rpc?.id &&
        vm.rpcItem?.id &&
        vm.currentTarget.rpc.id !== vm.rpcItem.id
      ) {
        vm.currentTarget.rpcSetting = null;
      }
      // If user selects to use parent RPC settings, null out the rpcSetting object and reset priorityBump
      if (!vm.overrideRpcSetting) {
        vm.currentTarget.rpcSetting = null;
      }

      if (isUpdating) {
        promiseTarget = targetService.updateTarget(
          accountsService.currentAccountId,
          vm.currentTarget
        );
      } else {
        promiseTarget = targetService.createTarget(
          accountsService.currentAccountId,
          vm.currentTarget
        );
      }

      promiseTarget = _deferredDealWithDuplicate(promiseTarget);

      promiseTarget = promiseTarget.then(function (response) {
        return _handleLinkRpc(response) || response;
      });

      promiseTarget = promiseTarget.then(function (response) {
        return _linkBuyerToTarget(response) || response;
      });

      return _deferredOnUpdate(promiseTarget, isUpdating);
    }

    function _handleLinkRpc(response) {
      const promise = $q.when(response);
      const targetId =
        response &&
        response.data &&
        response.data.target &&
        response.data.target.id;
      if (targetId) {
        if (vm.rpcItem && vm.rpcItem.id) {
          if (
            vm.rpcItem.id.substr(0, 2) === 'TA' &&
            vm.rpcItem.id.substr(-4) === 'LINK'
          )
            return;
          if (
            !vm.currentTarget.rpc ||
            vm.rpcItem.id !== vm.currentTarget.rpc.id ||
            vm.currentTarget.isDuplicate
          ) {
            return targetService.linkToItem(
              accountsService.currentAccountId,
              targetId,
              {
                memberName: 'RPC',
                memberId: vm.rpcItem.id
              }
            );
          }
        } else {
          if (vm.currentTarget.rpc && vm.currentTarget.rpc.id) {
            if (
              vm.currentTarget.rpc.id.substr(0, 2) === 'TA' &&
              vm.currentTarget.rpc.id.substr(-4) === 'LINK'
            )
              return;
            return targetService.unlinkItem(
              accountsService.currentAccountId,
              targetId,
              {
                memberName: 'RPC',
                memberId: vm.currentTarget.rpc.id
              }
            );
          }
        }
      }

      return promise;
    }

    function _linkBuyerToTarget(response) {
      let promise = $q.when(response);
      const targetId =
        response &&
        response.data &&
        response.data.target &&
        response.data.target.id;
      if (targetId) {
        if (
          vm.targetOwnerCopy &&
          (!vm.currentTarget.owner ||
            !vm.currentTarget.owner.id ||
            vm.currentTarget.owner.id != vm.targetOwnerCopy.id)
        ) {
          promise = buyerService.unlinkBuyerTarget(
            accountsService.currentAccountId,
            targetId,
            vm.targetOwnerCopy.id
          );
        }
        if (
          vm.currentTarget.owner &&
          vm.currentTarget.owner.id &&
          (!vm.targetOwnerCopy ||
            vm.currentTarget.owner.id != vm.targetOwnerCopy.id ||
            (vm.targetOwnerCopy && !vm.currentTarget.id))
        ) {
          return promise.then(function () {
            return buyerService.linkBuyerToTarget(
              accountsService.currentAccountId,
              targetId,
              { buyerId: vm.currentTarget.owner.id }
            );
          });
        }
      }

      return promise;
    }

    // TODO: Push this up to the select-target component
    function _loadTimeZones() {
      infoService.getTimeZones().then(function (response) {
        vm.timeZones = response.data;
      });
    }

    // Set values for call cap toggles
    function _initializeCallCaps() {
      capSettingsService.sanitizeCapPerDayOfWeekFromSingleValue(
        vm.currentTarget.schedule,
        'dailyCap',
        'dailyCapDayOfWeek'
      );
      capSettingsService.sanitizeCapPerDayOfWeekFromSingleValue(
        vm.currentTarget.schedule,
        'dailySumCap',
        'dailySumCapDayOfWeek'
      );

      if (vm.currentTarget.schedule.allTimeCap >= 0) {
        vm.callCaps.allTimeCap = 1;
      } else {
        delete vm.currentTarget.schedule.allTimeCap;
      }
      if (vm.currentTarget.schedule.monthlyCap >= 0) {
        vm.callCaps.monthlyCap = 1;
      } else {
        delete vm.currentTarget.schedule.monthlyCap;
      }
      if (vm.currentTarget.schedule.dailyCap >= 0) {
        vm.callCaps.dailyCap = 1;
      } else {
        delete vm.currentTarget.schedule.dailyCap;
      }

      if (
        vm.currentTarget.schedule.dailyCapDayOfWeek != undefined &&
        vm.currentTarget.schedule.dailyCapDayOfWeek.length > 0
      ) {
        vm.callCaps.dailyCap = 1;
      }

      vm.currentTarget.schedule.dailyCapDayOfWeek = capSettingsService.sanitizeDOWCapToDisplay(
        vm.currentTarget.schedule.dailyCapDayOfWeek
      );

      if (vm.currentTarget.schedule.callCapMatrix != null) {
        //set -1 to nulls
        for (let day = 0; day < 7; day++) {
          for (let hour = 0; hour < 24; hour++) {
            if (vm.currentTarget.schedule.callCapMatrix[day][hour] == -1) {
              vm.currentTarget.schedule.callCapMatrix[day][hour] = null;
            }
          }
        }

        const allSame = _isBasicHourlyCap(
          vm.currentTarget.schedule.callCapMatrix
        );
        if (allSame && vm.currentTarget.schedule.callCapMatrix[0][0] == null) {
          vm.currentTarget.schedule.callCapMatrix = null;
        }
      }

      if (
        vm.currentTarget.schedule.hourlyCap >= 0 ||
        vm.currentTarget.schedule.callCapMatrix != null
      ) {
        vm.callCaps.hourlyCap = 1;
        if (vm.currentTarget.schedule.callCapMatrix == null) {
          //build matrix with full data.
          vm.currentTarget.schedule.callCapMatrix = targetService.createMatrix(
            vm.currentTarget.schedule.hourlyCap
          );
          //start discarding this property to only use the matrix
          vm.currentTarget.schedule.hourlyCap = -1;
        }
      } else {
        delete vm.currentTarget.schedule.hourlyCap;
        delete vm.currentTarget.schedule.callCapMatrix;
      }

      if (vm.currentTarget.schedule.allTimeSumCap >= 0) {
        vm.callCaps.allTimeSumCap = 1;
      } else {
        delete vm.currentTarget.schedule.allTimeSumCap;
      }
      if (vm.currentTarget.schedule.monthlySumCap >= 0) {
        vm.callCaps.monthlySumCap = 1;
      } else {
        delete vm.currentTarget.schedule.monthlySumCap;
      }
      if (vm.currentTarget.schedule.dailySumCap >= 0) {
        vm.callCaps.dailySumCap = 1;
      } else {
        delete vm.currentTarget.schedule.dailySumCap;
      }
      if (vm.currentTarget.schedule.hourlySumCap >= 0) {
        vm.callCaps.hourlySumCap = 1;
      } else {
        delete vm.currentTarget.schedule.hourlySumCap;
      }

      if (vm.currentTarget.schedule.concurrencyCap >= 0) {
        vm.callCaps.concurrencyCap = 1;
      } else {
        delete vm.currentTarget.schedule.concurrencyCap;
      }

      if (
        vm.currentTarget.schedule.dailySumCapDayOfWeek != undefined &&
        vm.currentTarget.schedule.dailySumCapDayOfWeek.length > 0
      ) {
        vm.callCaps.dailySumCap = 1;
      }

      vm.currentTarget.schedule.dailySumCapDayOfWeek = capSettingsService.sanitizeDOWCapToDisplay(
        vm.currentTarget.schedule.dailySumCapDayOfWeek
      );
    }

    // Reset values of call caps based on toggle position
    function _resetCallCaps() {
      if (vm.callCaps.allTimeCap === -1) {
        vm.currentTarget.schedule.allTimeCap = -1;
      }
      if (vm.callCaps.monthlyCap === -1) {
        vm.currentTarget.schedule.monthlyCap = -1;
      }

      if (vm.callCaps.dailyCap === -1) {
        vm.currentTarget.schedule.dailyCap = -1;
        vm.currentTarget.schedule.dailyCapDayOfWeek = null;
      } else {
        vm.currentTarget.schedule.dailyCapDayOfWeek = capSettingsService.sanitizeDOWCapToStore(
          vm.currentTarget.schedule.dailyCapDayOfWeek
        );
      }

      if (vm.callCaps.hourlyCap === -1) {
        vm.currentTarget.schedule.hourlyCap = -1;
        vm.currentTarget.schedule.callCapMatrix = null;
      } else {
        vm.currentTarget.schedule.callCapMatrix =
          vm.currentTarget.schedule.callCapMatrix ||
          targetService.createMatrix(undefined);
        //set nulls to -1
        for (let day = 0; day < 7; day++) {
          for (let hour = 0; hour < 24; hour++) {
            // if (vm.currentTarget.schedule.callCapMatrix[day][hour] == null || vm.currentTarget.schedule.callCapMatrix[day][hour] == '')
            if (vm.currentTarget.schedule.callCapMatrix[day][hour] == null) {
              vm.currentTarget.schedule.callCapMatrix[day][hour] = -1;
            }
          }
        }
      }

      if (vm.callCaps.allTimeSumCap === -1) {
        vm.currentTarget.schedule.allTimeSumCap = -1;
      }
      if (vm.callCaps.monthlySumCap === -1) {
        vm.currentTarget.schedule.monthlySumCap = -1;
      }

      if (vm.callCaps.dailySumCap === -1) {
        vm.currentTarget.schedule.dailySumCap = -1;
        vm.currentTarget.schedule.dailySumCapDayOfWeek = null;
      } else {
        vm.currentTarget.schedule.dailySumCapDayOfWeek = capSettingsService.sanitizeDOWCapToStore(
          vm.currentTarget.schedule.dailySumCapDayOfWeek
        );
      }

      if (vm.callCaps.hourlySumCap === -1) {
        vm.currentTarget.schedule.hourlySumCap = -1;
      }

      _resetConcurrencyCaps();
    }

    function _resetConcurrencyCaps() {
      if (vm.callCaps.concurrencyCap === -1) {
        vm.currentTarget.schedule.concurrencyCap = -1;
      }
      if (!vm.setConcurrency) {
        vm.currentTarget.schedule.callConcurrencyMatrix = null;
      }
    }

    function _resetHours() {
      if (!vm.setHours) {
        vm.currentTarget.schedule.hoursOfOperation = null;
      }
    }

    function _loadBuyers() {
      buyerService
        .getBuyers(accountsService.currentAccountId)
        .then(function (response) {
          vm.buyers = response.data.buyers;
          _loadAccountSettings();
        });
    }

    function _isBasicHourlyCap(matrix) {
      const compareHour = matrix[0][0];
      return _.every(matrix, function (day) {
        return _.every(day, function (hour) {
          return _.isEqual(hour, compareHour);
        });
      });
    }

    function _isBasicConcurrency(matrix) {
      const compareDay = matrix[0];
      return _.every(matrix, function (day) {
        return _.isEqual(day, compareDay);
      });
    }

    function _checkAndShowTagFilter() {
      if (vm.currentTarget.criteria && vm.currentTarget.criteria.length) {
        vm.isTagFilterSectionOpen = true;
        vm.showFullWidthOptions.showSummaryView = true;
      }
    }

    async function _loadTags() {
      vm.isLoadingTags = true;
      try {
        const response = await tagService.getTags(
          accountsService.currentAccountId
        );
        vm.availableTags = response.data;
      } catch (e) {
        utils.errorHandler(e);
      } finally {
        vm.isLoadingTags = false;
      }
    }

    function _processShareableTags() {
      vm.currentTarget.shareableTagSetting = tagService.getShareableTags(
        vm.currentTarget.shareableTagSetting,
        vm.availableTags
      );
      if (vm.currentTarget.shareableTagSetting.macroTagstoShare)
        vm.overrideShareableTags = true;
    }

    function _resetShareableTags() {
      vm.currentTarget.shareableTagSetting = null;
    }

    function _initRpcOptions() {
      vm.rpcOptions = [
        {
          name: vm.parentRPCSettingLabel,
          value: false
        },
        {
          name: $filter('translate')('USE_ERPC'),
          value: true
        }
      ];
    }

    function _initRpcSettingItem() {
      if (vm.currentTarget.rpc && vm.currentTarget.rpc.id) {
        vm.rpcItem = angular.copy(vm.currentTarget.rpc);
        vm.overrideRpcSetting = true;
        return;
      }
      vm.rpcItem = {
        enabled: false,
        id: ''
      };
    }

    function validateTagRoutingFilters() {
      if (vm.currentTarget.criteria?.length) {
        vm.isTagRoutingFiltersInvalid = vm.currentTarget.criteria.some(criteria => criteria.tagCriteria.some(tc => !tc.tagIds[0]));
      }
    }

    function _tryGetBuyerRpcSettings() {
      if (vm.currentTarget.owner && vm.currentTarget.owner.id) {
        return vm.buyers.find(function (buyer) {
          return buyer.id === vm.currentTarget.owner.id;
        }).rpcSetting;
      } else {
        return null;
      }
    }

    function _loadAccountSettings() {
      accountSettingsService
        .loadSettings(accountsService.currentAccountId)
        .then(function (response) {
          vm.accountSettings = response.data.accountSettings;

          _loadRpcSettingsInContext();
          _initRpcOptions();
        });
    }

    function _loadRpcSettingsInContext() {
      const buyerRpcSetting = _tryGetBuyerRpcSettings();

      if (buyerRpcSetting != null) {
        vm.parentRPCSettings = buyerRpcSetting;
        vm.parentRPCSettingLabel = $filter('translate')('USE_BUYER_SETTING');
        vm.buyerExternalLink =
          '/#/dashboard/buyer/' + vm.currentTarget.owner.id;
      } else {
        vm.parentRPCSettingLabel = $filter('translate')('USE_CAMPAIGN_SETTING');
      }

      if (vm.currentTarget.rpcSetting) {
        vm.rpcSettingInContext = vm.currentTarget.rpcSetting;
        vm.isRpcSettingReadOnly = false;
      } else {
        vm.rpcSettingInContext = vm.parentRPCSettings;
        vm.isRpcSettingReadOnly = true;
      }
    }

    function matrixUpdated(newVal) {
      vm.currentTarget.schedule = vm.currentTarget.schedule || {};
      vm.currentTarget.schedule.callCapMatrix = newVal;
    }

    function onWeekDayMatrixUpdated(newVal) {
      vm.currentTarget.schedule = vm.currentTarget.schedule || {};
      vm.currentTarget.schedule.dailyCapDayOfWeek = newVal;
    }

    function onWeekDaySumMatrixUpdated(newVal) {
      vm.currentTarget.schedule = vm.currentTarget.schedule || {};
      vm.currentTarget.schedule.dailySumCapDayOfWeek = newVal;
    }

    function toggleSetHours() {
      if (vm.currentTarget?.schedule?.hoursOfOperation && !vm.setHours) {
        vm.setHours = true;
      }
    }
    function onRefreshBuyers() {
      vm.isRefreshingBuyers = true;
      try {
        _loadBuyers();
      } finally {
        $timeout(() => {
          vm.isRefreshingBuyers = false;
          $scope.$digest();
        }, 600);

      }
    }
    function updateRevenueRecoverySetting(setting) {
      vm.currentTarget.hangupRerouteSetting = setting;
      vm.isRevenueRecoveryInvalid = vm.currentTarget.hangupRerouteSetting?.maxRerouteAttempts > 5 || vm.currentTarget.hangupRerouteSetting?.maxRerouteAttempts < 0;
    }
    // Based on whether the target has a buyer selected, set the first option name in the multi toggle
    function _initRevenueRecoveryParentSetting() {
      if (vm.currentTarget.owner?.id) {
        vm.revenueRecoverySettingsOptions[0].name = $filter('translate')('USE_BUYER_SETTING');
      } else {
        vm.revenueRecoverySettingsOptions[0].name = $filter('translate')('USE_CAMPAIGN_SETTING');
      }
    }

    function onUpdateSipHeaders(headers) {
      if (!vm.currentTarget.instructions) {
        vm.currentTarget.instructions = {};
      }
      if (!vm.currentTarget.instructions.sip) {
        vm.currentTarget.instructions.sip = {};
      }
      vm.currentTarget.instructions.sip.headers = headers;
      vm.currentTarget.instructions.sip.useNewHeaders = Object.keys(vm.currentTarget.instructions.sip.headers).length > 0;
    }
  }
})();
